export interface RecordHomeExperienceInput {
  /** The returns experience is on for this user, from `useReturnsExperience`. */
  experienceOn: boolean;
  sourceEnabled: boolean;
}

export function resolveRecordHomeExperience({
  experienceOn,
  sourceEnabled,
}: RecordHomeExperienceInput): { useNewUi: boolean } {
  return { useNewUi: experienceOn && sourceEnabled };
}
